import colors from '@theme/colors';
import React from 'react';
import { ViewStyle, Modal, TouchableOpacity } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import styles from './styles';

interface MyModalProps {
  isVisible: boolean;
  onPress?: () => void;
  children?: React.ReactNode;
  containerStyle?: ViewStyle;
  hasBackdrop?: boolean;
  backdropOpacity?: number;
  onModalHide?: () => void;
  testID?: string;
  statusBarTranslucent?: boolean;
}

const MyModal: React.FC<MyModalProps> = ({
  isVisible = false,
  onPress = () => {},
  children = null,
  containerStyle = {},
  onModalHide = () => {},
  testID = `modalBackdrop`,
  ...props
}) => {
  // Remove ref and useEffect - control with index prop

  const handleClose = () => {
    onPress();
    onModalHide();
  };

  return (
    <Modal
      visible={isVisible}
      animationType="none"
      presentationStyle="overFullScreen"
      transparent
      onRequestClose={handleClose}
      {...props}>
      <TouchableOpacity
        testID={testID}
        accessible={false}
        importantForAccessibility="no"
        style={styles.backdrop}
        activeOpacity={1}
        onPress={handleClose}>
        <TouchableOpacity
          accessible={false}
          importantForAccessibility="no"
          style={[
            { backgroundColor: colors.neutral.cotton },
            styles.modalContainer,
            props.outerContainerStyle || styles.heightCommon,
          ]}
          activeOpacity={1}
          onPress={e => e.stopPropagation()}>
          <SafeAreaView
            accessible={false}
            importantForAccessibility="yes"
            accessibilityViewIsModal
            edges={['bottom']}
            style={styles.modalParent(containerStyle)}>
            {children}
          </SafeAreaView>
        </TouchableOpacity>
      </TouchableOpacity>
    </Modal>
  );
};

export default MyModal;
